type Listener = (...args: any[]) => void;

class AppEventEmitter {
  private listeners: Record<string, Listener[]> = {};

  on(event: string, fn: Listener): () => void {
    if (!this.listeners[event]) this.listeners[event] = [];
    this.listeners[event].push(fn);
    return () => {
      this.listeners[event] = this.listeners[event].filter((l) => l !== fn);
    };
  }

  emit(event: string, ...args: any[]) {
    this.listeners[event]?.forEach((fn) => fn(...args));
  }
}

export const appEvents = new AppEventEmitter();
